import React, { useEffect, useState, useRef } from "react";
import InboxList from '../../../../../globalcomponents/inboxList';
import EmailDetail from '../../../../../globalcomponents/inboxDetail';
import SentList from '../../../../../globalcomponents/sentList';
import SentDetail from '../../../../../globalcomponents/sentDetail';
import { withRouter } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import ChipInput from 'material-ui-chip-input';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import FormHoc from '../../../hoc/formHoc';
import { InputField, AutoOptionsNew } from '../../../formElements';
import { oldgenericApi } from '../../../../../../src/common/apiconfig';
import { apiCall } from '../../../../common/apiconfig';
import Snackbar from '../../../../../../src/common/snackbar';
import { connect } from 'react-redux';
import JoditEditor from "jodit-react";
import { editorConfig } from "../../../../../../src/common/constants";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography, Button } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import moment from 'moment';
import clsx from "clsx";


const useStyles = makeStyles(theme => ({
  sidebar: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 'full'
  },
  sidebarButton: {
    justifyContent: "flex-start",
    textTransform: "none",
    marginBottom: theme.spacing(1),
    "&:hover": {
      backgroundColor: theme.palette.action.hover,
    }
  },
  sidebarButtonActive: {
    backgroundColor: theme.palette.action.selected,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    "&:hover": {
      backgroundColor: theme.palette.action.selected,
    }
  },
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(3),
    },
  },
}));



const Email = (propsobj) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState("");
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false)
  const [variant, setVariant] = React.useState("")
  const [msg, setMsg] = useState("")
  const [inboxData, setInboxData] = useState([]);
  const [sentMailData, setSentMailData] = useState([]);
  const [usersValue, setUsersValue] = useState([]);
  const [progress, setProgress] = useState(false);
  const [todata, setToData] = useState([]);
  const [ccData, setCcData] = useState([]);
  const [ccInputValue, setCcInputValue] = useState('');
  const [ccUsersValue, setCcUsersValue] = useState([]);
  const [CCdata, setCCdata] = useState([]);
  const [BCCdata, setBCCdata] = useState([]);
  const [hideccbtn, setHideccbtn] = useState(true);
  const [showcc, setShowcc] = useState(false);
  const [hidebccbtn, setHidebccbtn] = useState(true);
  const [showbcc, setShowbcc] = useState(false);
  const [content, setContent] = useState('');
  const [templateData, setTemplateData] = useState([]);
  const [templateId, settemplateId] = useState({});
  const [showNewMail, setShowNewMail] = useState(false);
  const [showInbox, setShowInbox] = useState(true);
  const [showSent, setShowSent] = useState(false);
  const [selectedInboxEmail, setSelectedInboxEmail] = useState(null);
  const [selectedSentEmail, setSelectedSentEmail] = useState(null);
  const [activeTab, setActiveTab] = useState("new");
  const editor = useRef(null);


  const contacts = [
    {
      contactName: "Oliven Yews",
      email: "balaanbalagan05@gmail.com",
    },
    {
      contactName: "sg shanm",
      email: "shanker_it@yahoo.com",
    },
  ];


  useEffect(() => {
    propsobj.UpdateFormField({ name: "fromtext", value: localStorage.getItem("loggedUserEmail") });
    propsobj.UpdateFormField({ name: "ipSubject", value: "" });
    // callGetTemplatesApi();
    fetchData();
    getMails();
    getSentMails();
    setSelectedSentEmail(false);
    setSelectedInboxEmail(false);
  }, []);


  async function fetchData() {
    let requestBody = {
      query: `query {
        getStudySiteContact(studyId:"${propsobj.formValues.studyId}",siteId:"${propsobj.formValues.siteId}") {
          studyId
          siteId
          contactId
          contactName
          role
          primaryContactInd
          email
          phone
          status
          createdBy
          createdTs
          modifiedBy
          modifiedTs
                }
              }`
    };

    requestBody = JSON.stringify(requestBody);
    setProgress(true);
    let res = await apiCall('getStudySiteContact', requestBody);
    console.log(res, "res")
    setProgress(false);
    if (!res) {
      // Error handling
      console.log('Error on response material grid!')

    } else {
      if (res.data.getStudySiteContact.length) {

        setData(res.data.getStudySiteContact)
        propsobj.UpdateFormField({ name: "sitecontacts", value: JSON.stringify(res.data.getStudySiteContact) })
      } else {
        setData([])
        propsobj.UpdateFormField({ name: "sitecontacts", value: "" })
      }
    }
  }



  const hocObj = FormHoc(propsobj);

  const textProps = {
    ...hocObj,
    propsobj
  };
  console.log(propsobj.formValues.autosite.sponsorAccountId, "userid")
  const getMails = async () => {
    const { autostudy, autosite } = propsobj.formValues;
    console.log(autostudy.studyId, "studyId")
    let requestBody = `
    query {
      getStudySiteEmails(
        studyId: "${propsobj.formValues.studyId}",
        siteId: "${propsobj.formValues.siteId}",
        fromType: "Site",
        toType: "Sponsor",
        searchStr: "*"
      ) {
        fromUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        toUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        ccUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        emailSubject
        emailBody
        createdBy
        timeStamp
        studyId
        siteId
        fromType
        toType
      }
    }
  `;

    requestBody = JSON.stringify({ query: requestBody });
    setProgress(true);

    const res = await oldgenericApi('getStudySiteEmails', requestBody);
    setProgress(false);

    if (res?.data?.getStudySiteEmails) {

      setInboxData(res);
      console.log(res, "res")
        ;
    } else {
      console.error("Failed to fetch study site emails.");
    }
  };



  const getSentMails = async () => {
    const { autostudy, autosite } = propsobj.formValues;
    console.log(autostudy.studyId, "studyId")
    let requestBody = `
    query {
      getStudySiteEmails(
        studyId: "${propsobj.formValues.studyId}",
        siteId: "${propsobj.formValues.siteId}",
        fromType: "Sponsor",
        toType: "Site",
        searchStr: "*"
      ) {
        fromUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        toUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        ccUser {
          sponsorAccountUserId
          sponsorAccountId
          SponsorAccountName
          firstName
          middleName
          lastName
          email
          phone
          roleId
          role
          language
          portalAccessInd
          invitedBy
          invitedDate
          activated
          primaryContactInd
          createdBy
          createdTs
          modifiedBy
          modifiedTs
          position
        }
        emailSubject
        emailBody
        createdBy
        timeStamp
        studyId
        siteId
        fromType
        toType
      }
    }
  `;

    requestBody = JSON.stringify({ query: requestBody });
    setProgress(true);

    const res = await oldgenericApi('getStudySiteEmails', requestBody);
    setProgress(false);

    if (res?.data?.getStudySiteEmails) {

      setSentMailData(res);
      console.log(res, "res");
    } else {
      console.error("Failed to fetch study site emails.");
    }
  };


  const autoPropstotemplates = {
    options: templateData,
    default: null,
    freeSolo: false,
    propsobj,
    keys: ['value']
  };

  const handleToChip = (chip) => {
    setToData((prev) => {
      if (!prev.some((c) => c.value === chip.value)) {
        return [...prev, chip];
      }
      return prev;
    });
    setInputValue(""); // Clear input after adding
  };

  const handleCCChip = (chip) => setCCdata([...CCdata, chip]);
  const handleBCCChip = (chip) => setBCCdata([...BCCdata, chip]);

  const handleDeleteToChip = (chipToDelete) => {
    setToData(todata.filter((chip) => chip !== chipToDelete));
  };
  const getSuggestions = (input) => {
    const query = input.toLowerCase();
    return data
      .filter((c) => c.contactName.toLowerCase().includes(query))
      .map((c) => ({
        label: `${c.contactName} <${c.email}>`,
        value: c.email,
        id: c.contactId
      }));
  };



  const sendInvite = async (e) => {
    e.preventDefault();

    const stringifyTodata = todata.map(item => `"${item}"`);
    const stringifyCCdata = CCdata.map(item => `"${item}"`);
    const stringifyBCCdata = BCCdata.map(item => `"${item}"`);
    const rawHtml = editor.current.value;

    const contactIds = usersValue.map(item => `"${item.id}"`);
    const ccContactIds = ccData.map(c => `"${c.id}"`);
    if (stringifyTodata.length > 0) {
      const siteId = propsobj.formValues.autosite?.sponsorAccountId;
      const studyId = propsobj.formValues.autostudy?.studyId;
      const fromType = "Sponsor";
      const toType = "Site";

      const requestBody = JSON.stringify({
        query: `mutation {
        sendStudySiteEmail(
          fromId: "${localStorage.getItem('loginUserId')}",
          toId: [${contactIds}],
          ccId: [${ccContactIds}],
          bccId: [${stringifyBCCdata}],
          emailSubject: "${propsobj.formValues.ipSubject}",
          emailBody: ${JSON.stringify(rawHtml)},
          bulkMail: "Y",
          studyId: "${propsobj.formValues.studyId}",
          siteId: "${propsobj.formValues.siteId}",
          fromType: "${fromType}",
          toType: "${toType}"
        ) {
          code
          type
          message
          attributes
        }
      }`
      });

      setProgress(true);
      const res = await oldgenericApi("sendStudySiteEmail", requestBody);
      setProgress(false);

      if (res?.data?.sendStudySiteEmail?.code === "200") {
        setOpen(true)
        setVariant('success')
        setMsg(res?.data?.sendStudySiteEmail?.message)
        setToData([]);
        setCcData([]);
        setBCCdata([]);
        setHideccbtn(true);
        setShowcc(false);
        setContent("");
        editor.current.value = "";
        settemplateId({});
        getSentMails();
        propsobj.UpdateFormField({ name: "useTemplate", value: "" });
        propsobj.UpdateFormField({ name: "ipSubject", value: "" });

      } else {
        alert("Failed to send Email.");
      }
    } else {
      alert('Please Enter From and To');
    }
  };

  const handleCancel = (e) => {
    e.preventDefault();
    propsobj.history.goBack();
  };

  const handleTemplates = (obj) => {
    settemplateId(obj.selected);
    propsobj.UpdateFormField({ name: obj.name, value: obj.selected });
    setContent(obj.selected.body);
  };

  const handleNewMail = () => {
    setShowInbox(false);
    setShowSent(false);
    setShowNewMail(true);
    setSelectedInboxEmail(false);
    setSelectedSentEmail(null);
  }

  const handleOpenInbox = () => {
    setShowNewMail(false);
    setShowInbox(true);
    setShowSent(false);
    setSelectedInboxEmail(null);

  }

  const handleOpenSent = () => {
    setActiveTab("sent");
    setShowInbox(false);
    setShowNewMail(false);
    setShowSent(true);
    setSelectedInboxEmail(null);
    setSelectedSentEmail(null);
  };
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const formatDate = (timestamp) => {
    return moment(timestamp).format("MMM DD/YY");
  };

  console.log("usersValue ===>>>", usersValue);
  const top100Films = [
    { title: 'The Shawshank Redemption', year: 1994 },
    { title: 'The Godfather', year: 1972 },
    { title: 'The Godfather: Part II', year: 1974 },
    { title: 'The Dark Knight', year: 2008 },
    { title: '12 Angry Men', year: 1957 },
    { title: "Schindler's List", year: 1993 },
    { title: 'Pulp Fiction', year: 1994 },
    { title: 'The Lord of the Rings: The Return of the King', year: 2003 },
    { title: 'The Good, the Bad and the Ugly', year: 1966 },
    { title: 'Fight Club', year: 1999 },
    { title: 'The Lord of the Rings: The Fellowship of the Ring', year: 2001 },
    { title: 'Star Wars: Episode V - The Empire Strikes Back', year: 1980 },
    { title: 'Forrest Gump', year: 1994 },
    { title: 'Inception', year: 2010 },
    { title: 'The Lord of the Rings: The Two Towers', year: 2002 },
    { title: "One Flew Over the Cuckoo's Nest", year: 1975 },
    { title: 'Goodfellas', year: 1990 },
    { title: 'The Matrix', year: 1999 },
    { title: 'Seven Samurai', year: 1954 },
    { title: 'Star Wars: Episode IV - A New Hope', year: 1977 },
    { title: 'City of God', year: 2002 },
    { title: 'Se7en', year: 1995 },
    { title: 'The Silence of the Lambs', year: 1991 },
    { title: "It's a Wonderful Life", year: 1946 },
    { title: 'Life Is Beautiful', year: 1997 },
    { title: 'The Usual Suspects', year: 1995 },
    { title: 'Léon: The Professional', year: 1994 },
    { title: 'Spirited Away', year: 2001 },
    { title: 'Saving Private Ryan', year: 1998 },
    { title: 'Once Upon a Time in the West', year: 1968 },
    { title: 'American History X', year: 1998 },
    { title: 'Interstellar', year: 2014 },
    { title: 'Casablanca', year: 1942 },
    { title: 'City Lights', year: 1931 },
    { title: 'Psycho', year: 1960 },
    { title: 'The Green Mile', year: 1999 },
    { title: 'The Intouchables', year: 2011 },
    { title: 'Modern Times', year: 1936 },
    { title: 'Raiders of the Lost Ark', year: 1981 },
    { title: 'Rear Window', year: 1954 },
    { title: 'The Pianist', year: 2002 },
    { title: 'The Departed', year: 2006 },
    { title: 'Terminator 2: Judgment Day', year: 1991 },
    { title: 'Back to the Future', year: 1985 },
    { title: 'Whiplash', year: 2014 },
    { title: 'Gladiator', year: 2000 },
    { title: 'Memento', year: 2000 },
    { title: 'The Prestige', year: 2006 },
    { title: 'The Lion King', year: 1994 },
    { title: 'Apocalypse Now', year: 1979 },
    { title: 'Alien', year: 1979 },
    { title: 'Sunset Boulevard', year: 1950 },
    { title: 'Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb', year: 1964 },
    { title: 'The Great Dictator', year: 1940 },
    { title: 'Cinema Paradiso', year: 1988 },
    { title: 'The Lives of Others', year: 2006 },
    { title: 'Grave of the Fireflies', year: 1988 },
    { title: 'Paths of Glory', year: 1957 },
    { title: 'Django Unchained', year: 2012 },
    { title: 'The Shining', year: 1980 },
    { title: 'WALL·E', year: 2008 },
    { title: 'American Beauty', year: 1999 },
    { title: 'The Dark Knight Rises', year: 2012 },
    { title: 'Princess Mononoke', year: 1997 },
    { title: 'Aliens', year: 1986 },
    { title: 'Oldboy', year: 2003 },
    { title: 'Once Upon a Time in America', year: 1984 },
    { title: 'Witness for the Prosecution', year: 1957 },
    { title: 'Das Boot', year: 1981 },
    { title: 'Citizen Kane', year: 1941 },
    { title: 'North by Northwest', year: 1959 },
    { title: 'Vertigo', year: 1958 },
    { title: 'Star Wars: Episode VI - Return of the Jedi', year: 1983 },
    { title: 'Reservoir Dogs', year: 1992 },
    { title: 'Braveheart', year: 1995 },
    { title: 'M', year: 1931 },
    { title: 'Requiem for a Dream', year: 2000 },
    { title: 'Amélie', year: 2001 },
    { title: 'A Clockwork Orange', year: 1971 },
    { title: 'Like Stars on Earth', year: 2007 },
    { title: 'Taxi Driver', year: 1976 },
    { title: 'Lawrence of Arabia', year: 1962 },
    { title: 'Double Indemnity', year: 1944 },
    { title: 'Eternal Sunshine of the Spotless Mind', year: 2004 },
    { title: 'Amadeus', year: 1984 },
    { title: 'To Kill a Mockingbird', year: 1962 },
    { title: 'Toy Story 3', year: 2010 },
    { title: 'Logan', year: 2017 },
    { title: 'Full Metal Jacket', year: 1987 },
    { title: 'Dangal', year: 2016 },
    { title: 'The Sting', year: 1973 },
    { title: '2001: A Space Odyssey', year: 1968 },
    { title: "Singin' in the Rain", year: 1952 },
    { title: 'Toy Story', year: 1995 },
    { title: 'Bicycle Thieves', year: 1948 },
    { title: 'The Kid', year: 1921 },
    { title: 'Inglourious Basterds', year: 2009 },
    { title: 'Snatch', year: 2000 },
    { title: '3 Idiots', year: 2009 },
    { title: 'Monty Python and the Holy Grail', year: 1975 },
  ];

  return (
    <>
      {progress && (
        <div className="fullScreen">
          <CircularProgress className="progressCircle" size={100} thickness={1.5} />
        </div>
      )}
      <Snackbar open={open} variant={variant} message={msg} handleClose={handleClose} />





      <Grid container className={classes.root} spacing={2}>
        <Grid item xs={12} sm={12} md={2}>
          <Paper className={classes.sidebar}>
            <Button
              className={clsx(classes.sidebarButton, {
                [classes.sidebarButtonActive]: activeTab === "new"
              })}
              startIcon={<AddIcon />}
              onClick={() => { setActiveTab("new"); handleNewMail(); }}
              fullWidth
            >
              New Mail
            </Button>
            <Button
              className={clsx(classes.sidebarButton, {
                [classes.sidebarButtonActive]: activeTab === "inbox"
              })}
              onClick={() => { setActiveTab("inbox"); handleOpenInbox(); }}
              fullWidth
            >
              Inbox
            </Button>

            <Button
              className={clsx(classes.sidebarButton, {
                [classes.sidebarButtonActive]: activeTab === "sent"
              })}
              onClick={handleOpenSent}
              fullWidth
            >
              Sent Items
            </Button>
          </Paper>
        </Grid>
        <InboxList
          showInbox={showInbox}
          selectedEmail={selectedInboxEmail}
          showNewMail={showNewMail}
          mailData={inboxData}
          setSelectedEmail={setSelectedInboxEmail}
          setShowNewMail={setShowNewMail}
          formatDate={formatDate}
        />
        <EmailDetail
          selectedEmail={selectedInboxEmail}
          formatDate={formatDate}
          onClose={() => setSelectedInboxEmail(null)}
        />
        {showNewMail && (
          <Grid item xs={12} sm={12} md={10}>
            <Typography variant="h6" style={{ backgroundColor: '#D3D3D3', paddingLeft: '6px' }}>New Message</Typography>
            <form>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 emailcompose">
                      <InputField {...textProps} name="fromtext" must={'true'} type="text" InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <div style={{ color: "#C0C0C0" }} className="font14">From</div>
                          </InputAdornment>
                        )
                      }} />
                      <div style={{ paddingTop: '30px' }}>
                        <Autocomplete
                          multiple
                          limitTags={2}
                          id="multiple-limit-tags"
                          value={todata}
                          options={getSuggestions(inputValue)}
                          inputValue={inputValue}
                          onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.label
                          }
                          isOptionEqualToValue={(option, value) => option.value === value.value}
                          onChange={(event, value) => {

                            const uniqueValues = value.filter(
                              (v, i, self) => i === self.findIndex((o) => o.value === v.value)
                            );

                            setUsersValue(uniqueValues);
                            setToData(uniqueValues);
                          }}

                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label=""
                              placeholder=""
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <>
                                    <InputAdornment position="start">
                                      <div style={{ color: "#C0C0C0" }} className="font14">To</div>
                                    </InputAdornment>
                                    {params.InputProps.startAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />

                      </div>
                      <div style={{ paddingTop: '30px' }}>
                        <Autocomplete
                          multiple
                          limitTags={2}
                          id="multiple-cc-tags"
                          value={ccData}
                          options={getSuggestions(ccInputValue)}
                          inputValue={ccInputValue}
                          onInputChange={(event, newInputValue) => setCcInputValue(newInputValue)}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.label
                          }
                          isOptionEqualToValue={(option, value) => option.value === value.value}
                          onChange={(event, value) => {
                            const uniqueValues = value.filter(
                              (v, i, self) => i === self.findIndex((o) => o.value === v.value)
                            );
                            setCcUsersValue(uniqueValues);
                            setCcData(uniqueValues);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              variant="standard"
                              label=""
                              placeholder=""
                              InputProps={{
                                ...params.InputProps,
                                startAdornment: (
                                  <>
                                    <InputAdornment position="start">
                                      <div style={{ color: "#C0C0C0" }} className="font14">Cc</div>
                                    </InputAdornment>
                                    {params.InputProps.startAdornment}
                                  </>
                                ),
                              }}
                            />
                          )}
                        />
                      </div>


                      <div style={{ paddingTop: '30px' }}>
                        <InputField {...textProps} name="ipSubject" must={'false'} type="text" InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <div style={{ color: "#C0C0C0" }} className="font14">Subject</div>
                            </InputAdornment>
                          )
                        }} />
                      </div>


                      <br />
                      <div>
                        {/* <textarea class="form-control" style={{ height: "200px" }} placeholder="text message goes here" name="compose" value={compose} onChange={(e) => { setCompose(e.target.value) }} /> */}
                        <JoditEditor
                          ref={editor}
                          value={content}
                          config={editorConfig}
                          // tabIndex={1} // tabIndex of textarea
                          // onChange={(e) => { newhandle(e) }}
                          onBlur={newContent => setContent(newContent)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <br /> <div className="buttonContainer mr-auto" style={{
                display: "flex",
                justifyContent: "flex-end"
              }}>
                <button type="submit" className="btn btn-primary-blue btn-rounded btn-small mr-1" onClick={sendInvite}>SEND</button>
                {/* <button className="btn btn-primary-grey btn-rounded btn-small" onClick={handleCancel}>CANCEL</button> */}
              </div>
            </form>
          </Grid>
        )}
        <SentList
          showSent={showSent}
          selectedEmail={selectedSentEmail}
          mailData={sentMailData}
          setSelectedEmail={setSelectedSentEmail}
          formatDate={formatDate}
        />
        {showSent && selectedSentEmail && (
          <SentDetail
            selectedEmail={selectedSentEmail}
            formatDate={formatDate}
            onClose={() => setSelectedSentEmail(null)}
          />
        )}
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => ({
  formValues: state.form,
  state
});

const mapDispatchToProps = (dispatch) => ({
  UpdateFormField: (obj) => dispatch({ type: 'UpdateFormField', value: obj.value, name: obj.name }),
  clearForm: () => dispatch({ type: 'ClearForm' }),
  updateErrorObj: (obj) => dispatch({ type: 'updateErrorObj', flag: obj.flag, name: obj.name, text: obj.text }),
  updateEntireErrorObj: (errobj, errtextobj) => dispatch({ type: 'updateEntireErrorObj', errobj, errtextobj })
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Email));
